var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/components/Objects/Objects.jinja"] = require( "front/components/Objects/Objects.jinja" );
dependencies["front/components/Feedbacks/Feedbacks.jinja"] = require( "front/components/Feedbacks/Feedbacks.jinja" );
dependencies["front/components/IndexHero/IndexHero.jinja"] = require( "front/components/IndexHero/IndexHero.jinja" );
dependencies["front/components/Discount/Discount.jinja"] = require( "front/components/Discount/Discount.jinja" );
dependencies["front/components/IndexDescription/IndexDescription.jinja"] = require( "front/components/IndexDescription/IndexDescription.jinja" );
dependencies["front/components/IndexFeatures/IndexFeatures.jinja"] = require( "front/components/IndexFeatures/IndexFeatures.jinja" );
dependencies["front/components/IndexPartners/IndexPartners.jinja"] = require( "front/components/IndexPartners/IndexPartners.jinja" );
dependencies["front/components/IndexSlider/IndexSlider.jinja"] = require( "front/components/IndexSlider/IndexSlider.jinja" );
dependencies["front/components/IndexFinders/IndexFinders.jinja"] = require( "front/components/IndexFinders/IndexFinders.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/Index/IndexPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/components/Objects/Objects.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(Object.prototype.hasOwnProperty.call(t_1, "Objects")) {
var t_4 = t_1.Objects;
} else {
cb(new Error("cannot import 'Objects'")); return;
}
context.setVariable("Objects", t_4);
output += "\n";
env.getTemplate("front/components/Feedbacks/Feedbacks.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(Object.prototype.hasOwnProperty.call(t_5, "Feedbacks")) {
var t_8 = t_5.Feedbacks;
} else {
cb(new Error("cannot import 'Feedbacks'")); return;
}
context.setVariable("Feedbacks", t_8);
output += "\n\n";
if((lineno = 3, colno = 14, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isMobile"), "isMobile", context, [runtime.contextOrFrameLookup(context, frame, "request")]))) {
output += "\n    ";
var t_9;
t_9 = "объектов";
frame.set("objects_btn_text", t_9, true);
if(frame.topLevel) {
context.setVariable("objects_btn_text", t_9);
}
if(frame.topLevel) {
context.addExport("objects_btn_text", t_9);
}
output += "\n";
;
}
else {
output += "\n    ";
var t_10;
t_10 = "объектов в продаже";
frame.set("objects_btn_text", t_10, true);
if(frame.topLevel) {
context.setVariable("objects_btn_text", t_10);
}
if(frame.topLevel) {
context.addExport("objects_btn_text", t_10);
}
output += "\n";
;
}
output += "\n\n<div class=\"IndexPopup\">\n    <div class=\"IndexPopup-block IndexPopup-block--hero\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/IndexHero/IndexHero.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
callback(null,t_11);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_14,t_13) {
if(t_14) { cb(t_14); return; }
callback(null,t_13);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n    <div class=\"IndexPopup-block IndexPopup-block--discount\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/Discount/Discount.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
callback(null,t_15);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_18,t_17) {
if(t_18) { cb(t_18); return; }
callback(null,t_17);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n    ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "feedbacks"))) {
output += "\n        <div class=\"IndexPopup-block IndexPopup-block--feedbacks\">\n            ";
output += runtime.suppressValue((lineno = 18, colno = 24, runtime.callWrap(t_8, "Feedbacks", context, [runtime.makeKeywordArgs({"feedbacks": runtime.contextOrFrameLookup(context, frame, "feedbacks"),"addText": "Больше отзывов внутри разделов по&nbsp;продаже или покупке квартиры, комнаты или доли, по получению ипотеки.","addFeedbackMobilePosition": "bottom","isMobile": (lineno = 18, colno = 219, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isMobile"), "isMobile", context, [runtime.contextOrFrameLookup(context, frame, "request")]))})])), env.opts.autoescape);
output += "\n        </div>\n    ";
;
}
output += "\n    <div class=\"IndexPopup-block IndexPopup-block--description\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/IndexDescription/IndexDescription.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
callback(null,t_19);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_22,t_21) {
if(t_22) { cb(t_22); return; }
callback(null,t_21);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n    ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "objects"))) {
output += "\n        <div class=\"IndexPopup-block IndexPopup-block--objects\">\n            ";
output += runtime.suppressValue((lineno = 26, colno = 22, runtime.callWrap(t_4, "Objects", context, [runtime.makeKeywordArgs({"objects": runtime.contextOrFrameLookup(context, frame, "objects"),"button_text": runtime.contextOrFrameLookup(context, frame, "objects_btn_text"),"btn_type": "link","isMobile": (lineno = 26, colno = 104, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "isMobile"), "isMobile", context, [runtime.contextOrFrameLookup(context, frame, "request")])),"mods": ["index"]})])), env.opts.autoescape);
output += "\n        </div>\n    ";
;
}
output += "\n    <div class=\"IndexPopup-block IndexPopup-block--features\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/IndexFeatures/IndexFeatures.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_24,t_23) {
if(t_24) { cb(t_24); return; }
callback(null,t_23);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_26,t_25) {
if(t_26) { cb(t_26); return; }
callback(null,t_25);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n    <div class=\"IndexPopup-block IndexPopup-block--video\">\n        <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/gHqPNvj6skQ\" frameborder=\"0\"\n                allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\"\n                allowfullscreen></iframe>\n    </div>\n    <div class=\"IndexPopup-block IndexPopup-block--partners\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/IndexPartners/IndexPartners.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_28,t_27) {
if(t_28) { cb(t_28); return; }
callback(null,t_27);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_30,t_29) {
if(t_30) { cb(t_30); return; }
callback(null,t_29);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n    <div class=\"IndexPopup-block IndexPopup-block--slider\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/IndexSlider/IndexSlider.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_32,t_31) {
if(t_32) { cb(t_32); return; }
callback(null,t_31);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_34,t_33) {
if(t_34) { cb(t_34); return; }
callback(null,t_33);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n    <div class=\"IndexPopup-block IndexPopup-block--finders\">\n        ";
var tasks = [];
tasks.push(
function(callback) {
env.getTemplate("front/components/IndexFinders/IndexFinders.jinja", false, "assets/app/front/pages/Index/IndexPopup.jinja", false, function(t_36,t_35) {
if(t_36) { cb(t_36); return; }
callback(null,t_35);});
});
tasks.push(
function(template, callback){
template.render(context.getVariables(), frame, function(t_38,t_37) {
if(t_38) { cb(t_38); return; }
callback(null,t_37);});
});
tasks.push(
function(result, callback){
output += result;
callback(null);
});
env.waterfall(tasks, function(){
output += "\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/Index/IndexPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/Index/IndexPopup.jinja
// module id = 94
// module chunks = 0